import { makeStyles } from '@material-ui/core/styles'
import Color from 'color'

export default makeStyles((theme) => ({
  media: {
    paddingTop: '56.25%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },

  card: ({ color }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    borderRadius: '15px',
    position: 'relative',
    boxShadow: `0 0 2px 2px rgb(0 0 0 / 0.2)`,
    '&:hover': {
      boxShadow: `0 0 8px 2px ${Color(color)
        .rotate(-12)
        .darken(0.2)
        .fade(0.5)}`,
    },
  }),
  cardHeader: {
    height: '30px',
  },

  moreButton: {
    marginTop: '7px',
    marginRight: '5px',
    color: '#000',
  },
  roomTime: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#000',
  },
  title: {
    fontSize: '1rem',
    fontWeight: 500,
  },
  message: {
    opacity: 0.9,
    fontWeight: 420,
    fontSize: '0.8rem',
    margin: '10px 0 10px 0px',
  },
  cardActions: {
    padding: '0 16px 20px 16px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  cardAction: {
    display: 'block',
    textAlign: 'initial',
  },
  content: {
    flex: '1 0 auto',
  },
  categorynStatus: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  category: {
    fontSize: '0.7rem',
    fontWeight: 500,
    color: '#787A91',
    marginBottom: '5px',
  },
  progressTime: {
    fontSize: '0.7rem',
    fontWeight: 500,
    color: '#000',
    padding: 3,
    background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
    marginBottom: '5px',
  },
  timeTitle: {
    fontWeight: 500,
    fontSize: '0.7rem',
  },
  dateRoom: {
    fontSize: '0.75rem',
    fontWeight: 420,
    color: '#000',
  },
  timeRoom: {
    fontSize: '1rem',
    fontWeight: 550,
    color: '#000',
  },
  button: {
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '6px',
    margin: '0 auto',
    width: '100%',
    '&:hover': {
      background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
    },
  },
  buttonSmall: {
    borderRadius: '10px',
    width: '10px',
    color: '#000',
  },
}))
